import React from 'react';
import SmartDisplay from '../SmartDisplay/SmartDisplay';
import './Matrix.scss';
import { getModuleStatusStr} from '../../utils/utils';

const Matrix = ({ json, statusOfModule, org_rol,org_id, first, 
                  isLocked,
                  apcp, moduleAnswers,
                  setModuleAnswers,moduleErrors,setModuleErrors,
                  setLastUpdatedAt, setModuleStatus, setCatStatus, 
                  dispatcher, state, curcat}) => {
                    
  const {group_description, is_displayed, questions, cid, module, id} = json;
  const mid = module;
  const qgid = id;

  const contructQInfo =(updatedAt, updatedBy) =>{
    let rtn = '';
    if(!updatedAt&&!updatedBy) return rtn;
    rtn = rtn.concat("<p style='text-align:left'>");
    let newline = false;
    if(updatedAt){
      newline=true;
      rtn = rtn.concat(getModuleStatusStr('Last updated on:', updatedAt, true));

    }
    if(updatedBy){
      if(newline){
        rtn = rtn.concat('<br>');
      }
      rtn = rtn.concat('Last modified by: ').concat(updatedBy);
    }
    rtn = rtn.concat('</p>');
    return rtn;
  };

  const processQ = questions.map(el => {
    const {input_type, input_options, question_text, current_value, data_type, data_min, data_max, data_length, data_required, pattern,
      sequence_row, sequence_column, id, question_tooltip, is_read_only, question_tag,last_updated_at, last_updated_by} = el;
    const qid = id;

    return {inputType:input_type,
      inputOptions:input_options,
      questionText:question_text,
      question_tooltip:contructQInfo(last_updated_at, last_updated_by),
      currentValue: current_value,
      validators:{data_type, data_min, data_max, data_length, data_required, pattern},
      sequenceRow:sequence_row, sequenceColumn:sequence_column, cid, mid, qgid, qid,
      isReadOnly:is_read_only,
      qTag:question_tag,
      lastUpdatedBy: last_updated_by
    };
  });

  const groupArray = inputArray => {
    const seqRow = [];
    // use forEach over here as you are manipulating an array not returning one - kb
    inputArray.map(el => {
      const seq = el.sequenceRow;
      if (!seqRow.includes(seq)) {
        seqRow.push(seq);
      }
    });

    // use forEach over here as you are manipulating an array not returning one - kb
    const groupedArr = [];
    seqRow.map(rowNum => {
      const rowArr = inputArray.filter(el => el.sequenceRow === rowNum);
      const sortedRowArr = rowArr.sort((a, b) => a.sequenceColumn < b.sequenceColumn ? -1 : 1);
      groupedArr.push(sortedRowArr);
    });

    return groupedArr;
  };

  const mapQuestionsToRows = inputArray => {
    const sortedArray = inputArray.sort((a, b) => a.sequenceRow < b.sequenceRow ? -1 : 1);
    return groupArray(sortedArray);
  };
  const rows = mapQuestionsToRows(processQ);

  // we can put the conditions in a function so it is clearer whats going on. i dont get it: kb
  return (
    <div>
      <div className='matrixContainer cb-gutterv-24'>
        {first?'':<hr className='solid' />}
        {is_displayed&&group_description&&group_description!==''? <div className='row'><div className='col-xs-12 col-sm-12 col-md-12 marginTop40'>
          <p className='gdesc'>{group_description}</p>
        </div></div>:<div className='row' />}

        { //is there any other way of not returning O(n^2) onto the screen - kb - looks difficult
          rows.map((row, rindex) => (<div className='row matrixrow' key={`mr${rindex}`}>{
            row.map((col, cindex) => (<div key={`sd${rindex}${cindex}`} className={`${apcp?'apcplineup':'botlineup'} ${row.length>1?'col-md-6':'col-md-12'}`}>
              <SmartDisplay col={col} 
                halfInput={row.length>1}
                statusOfModule={statusOfModule}
                isLocked={isLocked}
                org_rol={org_rol}
                org_id={org_id}
                moduleAnswers={moduleAnswers}
                setModuleAnswers={setModuleAnswers}
                moduleErrors={moduleErrors}
                setModuleErrors={setModuleErrors} 
                setModuleStatus={setModuleStatus}
                setLastUpdatedAt={setLastUpdatedAt}
                setCatStatus={setCatStatus}
                apcp={apcp}
                dispatcher={dispatcher}
                sampleData={state?.sampleData}
                curcat={curcat}
                />

            </div>))
          }</div>))
        }
      </div>
    </div>
  );
};

export default Matrix;